(function () {
  const pbBrowniesRootsInited = new WeakSet();

  function pbFormatMoney(cents, formatStr) {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) return '';
    const amount = (Math.round(cents) / 100).toFixed(2);
    const fmt = formatStr || '{{ amount }}';
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/gi, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amount.replace('.', ','));
  }

  function pbGetQtyInput(root) {
    // The box-count pills drive this hidden input; fall back to a native quantity field.
    return root.querySelector('[data-pb-qty-input]') || root.querySelector('input[name="quantity"]');
  }

  function pbGetFormQuantity(root) {
    const input = pbGetQtyInput(root);
    if (!input) return 1;
    const n = parseInt(input.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function pbParseCents(v, fallback) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function pbAllocationPlanId(alloc) {
    if (!alloc) return '';
    if (alloc.selling_plan_id != null) return String(alloc.selling_plan_id);
    const sp = alloc.selling_plan;
    if (sp != null && sp.id != null) return String(sp.id);
    return '';
  }

  function pbApplyAllocationsToPlanOptions(plansEl, allocations) {
    const select = plansEl?.querySelector('.delivery-dropdown');
    if (!select || !Array.isArray(allocations)) return;
    const byPlan = new Map();
    for (let i = 0; i < allocations.length; i++) {
      const a = allocations[i];
      const pid = pbAllocationPlanId(a);
      if (pid) byPlan.set(pid, a);
    }
    for (let o = 0; o < select.options.length; o++) {
      const opt = select.options[o];
      const a = byPlan.get(String(opt.value));
      if (!a) continue;
      if (a.price != null) opt.dataset.pbPlanPriceCents = String(a.price);
      const cmp = a.compare_at_price;
      if (cmp != null) opt.dataset.pbPlanCompareCents = String(cmp);
    }
  }

  function pbSyncPurchaseFromSizeRadio(plansEl, radio) {
    if (!plansEl || !radio) return;
    const oc = radio.getAttribute('data-pb-onetime-price-cents');
    const cc = radio.getAttribute('data-pb-onetime-compare-cents');
    if (oc) plansEl.dataset.pbOnetimePriceCents = oc;
    if (cc) plansEl.dataset.pbOnetimeCompareCents = cc;
    const raw = radio.getAttribute('data-pb-allocations');
    let allocs = null;
    if (raw) {
      try {
        allocs = JSON.parse(raw);
      } catch (e) {
        allocs = null;
      }
    }
    pbApplyAllocationsToPlanOptions(plansEl, allocs);
  }

  function pbFormatPriceUnit(servings, qty, label) {
    const count = servings * qty;
    if (!label) return '';
    return '/' + count + ' ' + label;
  }

  function pbUpdateDisplayedPurchasePrices(root) {
    const plans = root.querySelector('[data-pb-purchase-options]');
    if (!plans) return;

    const format = plans.dataset.pbMoneyFormat || '';
    const servings = pbParseCents(plans.dataset.pbServings, 12) || 12;
    const unitLabel = plans.dataset.pbUnitLabel || '';
    const qty = pbGetFormQuantity(root);
    const unitText = pbFormatPriceUnit(servings, qty, unitLabel);

    const subscribeRadio = plans.querySelector('#subscribe-save');
    const isSubscribe = Boolean(subscribeRadio?.checked);

    const onetimeUnit = pbParseCents(plans.dataset.pbOnetimePriceCents, 0);
    const onetimeCompareUnit = pbParseCents(plans.dataset.pbOnetimeCompareCents, onetimeUnit);

    const deliveryDropdown = plans.querySelector('.delivery-dropdown');
    const selectedOpt = deliveryDropdown?.selectedOptions?.[0];

    let unitCents;
    if (isSubscribe && selectedOpt) {
      unitCents = pbParseCents(
        selectedOpt.dataset.pbPlanPriceCents,
        pbParseCents(plans.dataset.pbOnetimePriceCents, 0)
      );
    } else {
      unitCents = onetimeUnit;
    }

    const totalCents = unitCents * qty;

    const subValueEl = plans.querySelector('.pb-pdp-plan__price--subscribe .pb-pdp-plan__price-value');
    const subServingEl = plans.querySelector('.pb-pdp-plan__price--subscribe .pb-pdp-plan__price-serving');

    const otCompareEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-compare');
    const otValueEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-value');
    const otServingEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-serving');

    function paintSubscribeRow() {
      const u = selectedOpt
        ? pbParseCents(selectedOpt.dataset.pbPlanPriceCents, pbParseCents(plans.dataset.pbOnetimePriceCents, 0))
        : pbParseCents(plans.dataset.pbOnetimePriceCents, 0);
      // Main price reflects the full order (unit × box count); per-serving stays per-serving.
      if (subValueEl) subValueEl.textContent = pbFormatMoney(u * qty, format);
      if (subServingEl) {
        const per = servings > 0 ? Math.round(u / servings) : 0;
        subServingEl.textContent = pbFormatMoney(per, format) + ' / serving';
      }
    }

    function paintOnetimeRow() {
      const u = onetimeUnit;
      const c = onetimeCompareUnit;
      if (otCompareEl) {
        const show = c > u;
        otCompareEl.textContent = show ? pbFormatMoney(c * qty, format) : '';
        otCompareEl.hidden = !show;
      }
      if (otValueEl) otValueEl.textContent = pbFormatMoney(u * qty, format);
      if (otServingEl) {
        const per = servings > 0 ? Math.round(u / servings) : 0;
        otServingEl.textContent = pbFormatMoney(per, format) + ' / serving';
      }
    }

    paintSubscribeRow();
    paintOnetimeRow();

    plans.querySelectorAll('[data-pb-price-unit]').forEach((el) => {
      el.textContent = unitText;
    });

    const liveEl = root.querySelector('[data-pb-live-price]');
    if (liveEl) {
      const fmt = plans.dataset.pbMoneyFormat || liveEl.dataset.pbMoneyFormat || '';
      liveEl.textContent = pbFormatMoney(totalCents, fmt);
    }
  }

  function initGallery(root) {
    const track = root.querySelector('[data-pb-gallery-track]');
    const slides = root.querySelectorAll('[data-pb-gallery-slide]');
    const dots = root.querySelectorAll('[data-pb-gallery-dot]');
    const thumbs = root.querySelectorAll('[data-pb-gallery-thumb]');
    const thumbStrip = root.querySelector('[data-pb-gallery-thumbs]');
    const prev = root.querySelector('[data-pb-gallery-prev]');
    const next = root.querySelector('[data-pb-gallery-next]');
    const viewport = root.querySelector('[data-pb-gallery-viewport]');

    if (!track || !slides.length) return;

    let index = 0;
    let touchStartX = 0;
    let touchDeltaX = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === index);
        thumb.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      scrollActiveThumbIntoView();
    }

    function scrollActiveThumbIntoView() {
      if (!thumbStrip) return;
      const active = thumbs[index];
      if (!active) return;
      const pad = 8;
      const left = active.offsetLeft;
      const right = left + active.offsetWidth;
      const viewLeft = thumbStrip.scrollLeft;
      const viewRight = viewLeft + thumbStrip.clientWidth;
      if (left < viewLeft) {
        thumbStrip.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
      } else if (right > viewRight) {
        thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth + pad, behavior: 'smooth' });
      }
    }

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, n) => {
      dot.addEventListener('click', () => goTo(n));
    });
    thumbs.forEach((thumb, n) => {
      thumb.addEventListener('click', () => goTo(n));
    });

    if (viewport && slides.length > 1) {
      viewport.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'ArrowLeft') goTo(index - 1);
          if (e.key === 'ArrowRight') goTo(index + 1);
        },
        false
      );

      viewport.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (e) => {
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        () => {
          if (Math.abs(touchDeltaX) < 40) return;
          if (touchDeltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );
    }

    goTo(0);
  }

  function initFlavorScroll(root) {
    const grid = root.querySelector('[data-pb-flavors-grid]');
    const thumb = root.querySelector('[data-pb-flavors-thumb]');
    if (!grid || !thumb) return;

    function updateThumb() {
      const maxScroll = grid.scrollHeight - grid.clientHeight;
      if (maxScroll <= 0) {
        thumb.style.height = '100%';
        thumb.style.top = '0';
        return;
      }
      const ratio = grid.clientHeight / grid.scrollHeight;
      const thumbHeight = Math.max(ratio * 100, 12);
      const top = (grid.scrollTop / maxScroll) * (100 - thumbHeight);
      thumb.style.height = thumbHeight + '%';
      thumb.style.top = top + '%';
    }

    grid.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    updateThumb();
  }

  function initVariantFlavorDropdown(root) {
    // Dropdown is rendered via `pb-pdp-brownies-variant-dropdowns-flavor-dropdowns`
    // but we render it inside the real brownies PDP now.
    const picker = root.querySelector('[data-pb-brownies-variant-dropdowns-picker]');
    if (!picker) return;

    const select = picker.querySelector('.pb-common-product-dropdown__native');
    if (!(select instanceof HTMLSelectElement)) return;

    picker.addEventListener('change', () => {
      const opt = select.selectedOptions?.[0];
      if (!opt) return;

      const variantId = String(opt.value || '').trim();
      const productUrl = String(opt.dataset.productUrl || '').trim();
      if (!variantId || !productUrl) return;

      // Match current "cards" behavior: change URL to the chosen flavor product.
      window.location.assign(`${productUrl}?variant=${variantId}`);
    });
  }

  function initPurchaseOptions(root) {
    const plans = root.querySelector('[data-pb-purchase-options]');
    if (!plans) return;

    const subscribeRadio = plans.querySelector('#subscribe-save');
    const oneTimeRadio = plans.querySelector('#one-time');
    const deliveryDropdown = plans.querySelector('.delivery-dropdown');
    const sellingPlanInput = root.querySelector('[name="selling_plan"]');
    const subscribePlan = plans.querySelector('.pb-pdp-plan--subscribe');
    const onetimePlan = plans.querySelector('.pb-pdp-plan--onetime');

    function setSelectedState() {
      const isSubscribe = subscribeRadio?.checked;
      subscribePlan?.classList.toggle('is-selected', Boolean(isSubscribe));
      onetimePlan?.classList.toggle('is-selected', !isSubscribe);
    }

    function syncSellingPlan() {
      if (!sellingPlanInput) return;

      if (subscribeRadio?.checked && deliveryDropdown) {
        const selectedOption = deliveryDropdown.options[deliveryDropdown.selectedIndex];
        if (selectedOption) {
          sellingPlanInput.value = selectedOption.value;
          sellingPlanInput.removeAttribute('disabled');
        }
        const subSaveRadioButton = document.querySelector('[data-radio-subsave]');
        subSaveRadioButton?.click();
      } else {
        const oneTimeRadioButton = document.querySelector('[data-radio-onetime]');
        oneTimeRadioButton?.click();
        sellingPlanInput.setAttribute('disabled', 'disabled');
      }
    }

    function onPurchaseChange() {
      setSelectedState();
      syncSellingPlan();
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    }

    plans.querySelectorAll('input[name="purchase-option"]').forEach((radio) => {
      radio.addEventListener('change', onPurchaseChange);
    });

    deliveryDropdown?.addEventListener('change', () => {
      syncSellingPlan();
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    root.addEventListener('pb:static-size-change', () => {
      const staticWrap = root.querySelector('[data-pb-size-static]');
      const radio = staticWrap?.querySelector('.pb-pdp-size__input:checked');
      pbSyncPurchaseFromSizeRadio(plans, radio);
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    const form = root.querySelector('product-form form');
    form?.querySelector('input[name="quantity"]')?.addEventListener('input', () => {
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function pbBrowniesOnVariantChange(pbPayload) {
        if (String(pbPayload?.data?.sectionId) !== String(root.dataset.section)) return;
        const variant = pbPayload?.data?.variant;
        if (!variant) return;
        plans.dataset.pbOnetimePriceCents = String(variant.price);
        plans.dataset.pbOnetimeCompareCents = String(
          variant.compare_at_price != null ? variant.compare_at_price : variant.price
        );
        pbApplyAllocationsToPlanOptions(plans, variant.selling_plan_allocations);
        pbUpdateDisplayedPurchasePrices(root);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
    }

    setSelectedState();
    syncSellingPlan();
    pbUpdateDisplayedPurchasePrices(root);
  }

  function initStaticSizePicker(root) {
    const staticSize = root.querySelector('[data-pb-size-static]');
    if (!staticSize) return;

    const qtyInput = pbGetQtyInput(root);
    const radios = staticSize.querySelectorAll('.pb-pdp-size__input');

    function applySize(radio) {
      if (!radio) return;

      // Box count = quantity of the single SKU to add (1 / 2 / 3 / 4 boxes …).
      // These pills are not product variants — they only drive quantity.
      const count = parseInt(radio.dataset.pbBoxCount, 10);
      if (qtyInput && Number.isFinite(count) && count > 0) {
        qtyInput.value = String(count);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      root.dispatchEvent(new CustomEvent('pb:static-size-change', { bubbles: true }));
      pbUpdateDisplayedPurchasePrices(root);
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) applySize(radio);
      });
    });

    const checked = staticSize.querySelector('.pb-pdp-size__input:checked');
    if (!checked) return;

    const count = parseInt(checked.dataset.pbBoxCount, 10);
    const currentQty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
    if (qtyInput && Number.isFinite(count) && count > 0 && currentQty === count) {
      return;
    }

    applySize(checked);
  }

  function pbAtcSalePriceEnabled() {
    return Boolean(window.PB_THEME && window.PB_THEME.atcShowSalePrice);
  }

  function initAtcLabel(root) {
    const form = root.querySelector('product-form form');
    const btn = root.querySelector('.product-form__submit');
    if (!form || !btn) return;

    const base = btn.dataset.pbAtcBase || 'Add to Cart';

    function syncLabel() {
      const label = btn.querySelector('span') || btn;
      // Theme setting off: production label (live total). No strike, no bundle price.
      // Label span only, so the loading spinner stays in the button.
      if (!pbAtcSalePriceEnabled()) {
        const priceEl = root.querySelector('[data-pb-live-price]');
        const price = priceEl?.textContent?.trim();
        label.textContent = price ? base + ' — ' + price : base;
        return;
      }
      const plans = root.querySelector('[data-pb-purchase-options]');
      const live = root.querySelector('[data-pb-live-price]');
      const qty = pbGetFormQuantity(root);
      const fmt = (plans && plans.dataset.pbMoneyFormat) || (live && live.dataset.pbMoneyFormat) || '';
      let saleUnit = live ? pbParseCents(live.dataset.pbUnitCents, 0) : 0;
      let compareUnit = 0;
      const sizeRadio = root.querySelector('[data-pb-size-static] .pb-pdp-size__input:checked');
      const bundlePct = parseFloat(sizeRadio && sizeRadio.dataset.pbDiscountPercent);
      if (plans) {
        const onetimeUnit = pbParseCents(plans.dataset.pbOnetimePriceCents, 0);
        const subscribeRadio = plans.querySelector('#subscribe-save');
        // Liquid checks this radio when subscription_selected is true (brownies default).
        if (subscribeRadio && subscribeRadio.checked) {
          const opt = plans.querySelector('.delivery-dropdown')?.selectedOptions?.[0];
          saleUnit = pbParseCents(opt && opt.dataset.pbPlanPriceCents, onetimeUnit);
          const planCompare = pbParseCents(opt && opt.dataset.pbPlanCompareCents, 0);
          compareUnit = planCompare > saleUnit ? planCompare : 0;
        } else {
          saleUnit = onetimeUnit;
          if (Number.isFinite(bundlePct) && bundlePct > 0 && bundlePct < 100) {
            compareUnit = saleUnit;
            saleUnit = saleUnit - Math.floor((saleUnit * bundlePct) / 100);
          }
        }
      }
      if (compareUnit <= saleUnit) compareUnit = 0;
      label.replaceChildren();
      if (!saleUnit) {
        label.textContent = base;
        return;
      }
      label.append(document.createTextNode(base + ' — '));
      if (compareUnit) {
        const compare = document.createElement('s');
        compare.className = 'pb-pdp-atc-compare';
        compare.textContent = pbFormatMoney(compareUnit * qty, fmt);
        label.append(compare, document.createTextNode(' '));
      }
      label.append(document.createTextNode(pbFormatMoney(saleUnit * qty, fmt)));
    }

    form.addEventListener('change', () => setTimeout(syncLabel, 50));
    root.addEventListener('pb:purchase-option-change', () => setTimeout(syncLabel, 50));
    syncLabel();
  }

  function initIncludedAccordion(root) {
    const included = root.querySelector('[data-pb-pdp-included]');
    if (!included) return;

    const cards = included.querySelectorAll('.pb-pdp-included__card');
    cards.forEach((card) => {
      card.addEventListener('toggle', () => {
        if (!card.open) return;
        cards.forEach((other) => {
          if (other !== card) other.open = false;
        });
      });
    });
  }

  function initPdpUgcCarousel(ugc) {
    const track = ugc.querySelector('[data-pb-pdp-ugc-track]');
    if (!track) return;

    const prevBtn = ugc.querySelector('[data-pb-pdp-ugc-prev]');
    const nextBtn = ugc.querySelector('[data-pb-pdp-ugc-next]');
    const slideCount = parseInt(ugc.dataset.pbPdpUgcCount || '0', 10);

    function scrollStep() {
      const card = track.querySelector('[data-pb-pdp-ugc-slide]');
      if (!card) return 212;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (slideCount > 2) {
      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      }
    });

    let isDragging = false;
    let dragStartX = 0;
    let dragScrollLeft = 0;

    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      if (e.target.closest('[data-pb-pdp-ugc-trigger]')) return;
      isDragging = true;
      track.classList.add('is-dragging');
      dragStartX = e.pageX;
      dragScrollLeft = track.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      updateArrows();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      track.scrollLeft = dragScrollLeft - (e.pageX - dragStartX);
    });
  }

  function initPdpUgcVideos(root) {
    const ugc = root.querySelector('[data-pb-pdp-ugc]');
    if (!ugc || ugc.dataset.pbPdpUgcMounted === '1') return;
    ugc.dataset.pbPdpUgcMounted = '1';

    initPdpUgcCarousel(ugc);

    const track = ugc.querySelector('[data-pb-pdp-ugc-track]');
    const slides = ugc.querySelectorAll('[data-pb-pdp-ugc-slide]');

    function pauseOthers(exceptSlide) {
      slides.forEach((slide) => {
        if (slide === exceptSlide) return;
        const player = slide.querySelector('[data-pb-pdp-ugc-player]');
        if (!player) return;
        player.pause();
        player.currentTime = 0;
        slide.classList.remove('is-playing');
        const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
        }
      });
    }

    slides.forEach((slide) => {
      const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
      const player = slide.querySelector('[data-pb-pdp-ugc-player]');
      if (!trigger) return;

      const playLabel = trigger.getAttribute('data-pb-aria-play') || 'Play video';
      const pauseLabel = trigger.getAttribute('data-pb-aria-pause') || 'Pause video';

      trigger.addEventListener('click', () => {
        const externalHref = trigger.getAttribute('data-pb-pdp-ugc-href');

        if (!player) {
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
          return;
        }

        if (slide.classList.contains('is-playing')) {
          player.pause();
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          return;
        }

        pauseOthers(slide);
        slide.classList.add('is-playing');
        player.play().catch(() => {
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
        });
        trigger.setAttribute('aria-label', pauseLabel);
      });

      player?.addEventListener('ended', () => {
        slide.classList.remove('is-playing');
        trigger.setAttribute('aria-label', playLabel);
      });
    });

    if (track && slides.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) return;
            const slide = entry.target;
            const player = slide.querySelector('[data-pb-pdp-ugc-player]');
            if (!player || player.paused) return;
            player.pause();
            player.currentTime = 0;
            slide.classList.remove('is-playing');
            const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
            trigger?.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
          });
        },
        { root: track, threshold: 0.45 }
      );
      slides.forEach((slide) => io.observe(slide));
    }
  }

  function initBrowniesRoot(root) {
    if (!root || pbBrowniesRootsInited.has(root)) return;
    pbBrowniesRootsInited.add(root);

    initGallery(root);
    initFlavorScroll(root);
    initVariantFlavorDropdown(root);
    initPurchaseOptions(root);
    initStaticSizePicker(root);
    initAtcLabel(root);
    initIncludedAccordion(root);
    initPdpUgcVideos(root);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function pbBrowniesVariantLiveOnly(pbPayload) {
        if (String(pbPayload?.data?.sectionId) !== String(root.dataset.section)) return;
        if (root.querySelector('[data-pb-purchase-options]')) return;
        const variant = pbPayload?.data?.variant;
        const live = root.querySelector('[data-pb-live-price]');
        if (!variant || !live) return;
        const fmt = live.dataset.pbMoneyFormat || '';
        const q = pbGetFormQuantity(root);
        live.textContent = pbFormatMoney(pbParseCents(variant.price, 0) * q, fmt);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
    }
  }

  document.addEventListener('product-info:loaded', (e) => {
    const el = e.target;
    if (!el || typeof el.matches !== 'function' || !el.matches('[data-pb-pdp-brownies]')) return;
    initBrowniesRoot(el);
  });

  document.querySelectorAll('[data-pb-pdp-brownies]').forEach(initBrowniesRoot);
})();
